import script from "./UserCreate.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserCreate.vue?vue&type=script&lang=ts&setup=true"

import "./UserCreate.vue?vue&type=style&index=0&id=732962d0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-732962d0"]])

export default __exports__